<template>
    <div class="header-section">
        
        <h1 class="form-title">Member Setup</h1>
        <p class="form-subtitle"></p>
    </div>
    <div class="form-container">
       
        <h2>Section A: Personal Information</h2>
        <p>Start with the basics: Tell us who you are and how we can reach you.</p>
        <p>Fields marked(*) are mandatory</p>
        <div>
            <div class="form-grid">
                <!-- Last Name -->
                <div class="form-group">
                    <label>Last Name <span>*</span></label>
                    <input placeholder="Enter last name" v-model="lastName" type="text"  required/>
                </div>

                <!-- First Name -->
                <div class="form-group">
                    <label>First Name<span>*</span></label>
                    <input placeholder="Enter first name" v-model="firstName" type="text" required/>
                </div>

                <!-- Surname -->
                <div class="form-group">
                    <label>Other Names</label>
                    <input placeholder="Enter other names" v-model="otherName" type="text" />
                </div>

                <!-- Member Id -->
                <div class="form-group">
                    <label>Member Id</label>
                    <input placeholder="Enter member Id" v-model="memberId" type="text" />
                </div>

                <!-- Date of Birth -->
                <div class="form-group">
                    <label>Date of Birth<span>*</span></label>
                    <input v-model="dob" type="date" required/>
                </div>

                <!-- Nationality -->
                <div class="form-group">
                    <label>Nationality<span>*</span></label>
                    <input placeholder="Enter nationality" v-model="nationality" type="text" required />
                </div>

                <!-- Residential Address -->
                <div class="form-group">
                    <label>Residential Address<span>*</span></label>
                    <textarea  name="" id="" cols="30" rows="2" placeholder="Enter residential address" v-model="residential_address" required></textarea>
                </div>

                <!-- Phone -->
                <div class="form-group">
                    <label>Telephone Number<span>*</span></label>
                    <input placeholder="Enter phone number" v-model="phone" type="tel" required/>
                </div>

                <!-- Email -->
                <div class="form-group">
                    <label>Email Address<span>*</span></label>
                    <input placeholder="Enter e-mail address here" v-model="email" type="email" required/>
                </div>
                
            </div>

            <h2>Section B: Professional Information</h2>
            <p>Share your work details so we understand your professional background.</p>

            <div class="form-grid">

                 <!-- profession -->
                 <div class="form-group">
                    <label> Profession/Occupation:<span>*</span></label>
                    <input placeholder="What do you do?" v-model="profession" type="text" />
                </div>

                <!-- employer -->
                <div class="form-group">
                    <label> Name of Employer:<span>*</span></label>
                    <input placeholder="Where do you work?" v-model="employer" type="text" />
                </div>

                <!-- office address -->
                <div class="form-group">
                    <label> Office Address<span>*</span></label>
                    <textarea name="" id="" cols="30" rows="2" placeholder="Where is your office located?" v-model="empl_office_address"></textarea>
                </div>

                 <!-- office phone -->
                 <div class="form-group">
                    <label> Office Telephone</label>
                    <input placeholder="Enter work phone number" v-model="empl_office_phone" type="text" />
                </div>

                 <!-- Job Title -->
                 <div class="form-group">
                    <label> If self-employed, state nature of business<span>*</span></label>
                    <input placeholder="Enter here" v-model="jobTitle" type="text" />
                </div>

            </div>

             <!-- Family Details -->
             <h2>Section C: Family Information</h2>
            <p>
                Input the names, sex and date of birth of your children (Maximum of 6 Children, they must be under 25
                years of age) 
            </p>

            <div class="children-section">
                <div v-for="(child, index) in children" :key="index"
                    style="width: 100%; display: flex; justify-content: flex-start; align-items: center;">
                    <!-- Child Number -->
                    <p class="child-number">{{ index + 1 }}</p>

                    <div class="child-form">
                        <!-- Child Name -->
                        <div class="form-group">
                            <label>Child Name</label>
                            <input type="text" v-model="child.name" placeholder="Enter child's name" />
                        </div>

                        <div class="form-group">
                            <label>Sex</label>
                            <div class="sex-options">
                                <label>
                                    <input class="CheckBox" type="radio" value="Male" v-model="child.sex" />
                                    Male
                                </label>
                                <label>
                                    <input class="CheckBox" type="radio" value="Female" v-model="child.sex" />
                                    Female
                                </label>
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Date of Birth</label>
                            <input type="date" v-model="child.dob" 
                             @blur="validateDob(child, index)"
                            />
                        </div>
                    </div>

                    <!-- Remove Button -->
                    <button
                    type="button"
                    @click="removeChild(index)"
                    style="margin-left: 10px; background-color: red; color: white; border: none; border-radius: 50%; width: 25px; height: 25px; cursor: pointer;"
                    >
                    ×
                    </button>
                </div>

                <!-- Add Child Button -->
                <button type="button" class="add-child-btn" @click="addChild" :disabled="children.length >= 6">
                    Add +
                </button>
                <div style="display: flex;  margin-top: 5px; justify-content: flex-start; align-items: center;">
                    <CircleAlert style="color: red; margin-right: 5px;" size="8" />
                    <p style="font-size: 10px; padding: 0%; margin: 0%;">Maximum of 6 Children</p>
                </div>
            </div>
           
            <h2>Section D: Membership Details</h2>
            <p>Help us learn about your sporting interests and membership history.</p>

            <div class="form-grid">
                <!-- List -->
                <div class="form-group">
                    <label> Present membership(s) of other club?<span>*</span></label>
                    <textarea name="" id="" cols="30" rows="2" placeholder="Please list present membership of other club" v-model="club_members"></textarea>
                </div>

                <div class="form-group">
                    <label>Have you been expelled from other club?<span>*</span></label>
                    <div class="d-flex flex-row gap-3">
                    <label class="d-flex align-items-center">
                        <input class="radio-btn me-2" type="radio" name="option" id="yes" v-model="expelled" value="yes">
                        Yes
                    </label>
                    
                    <label class="d-flex align-items-center">
                        <input class="radio-btn me-2" type="radio" name="option" id="no" v-model="expelled" value="no">
                        No
                    </label>
                    </div>
                </div>

                <div class="form-group">
                    <label>If Yes, please state reason<span>*</span></label>
                    <input placeholder="Enter here" v-model="reason_expelled" type="text" required/>
                </div>
            </div>
            
            <div class="membership-form-grid">
                <div class="form-group">
                <label>Select any 2 Sections you would like to belong<span>*</span></label>
                <div class="membership-options">
                    <label class="d-flex align-items-center">
                    <input 
                        type="checkbox" 
                        class="radio-btn me-2" 
                        value="Lawn Tennis" 
                        :disabled="games_play.length >= 2 && !games_play.includes('Lawn Tennis')"
                        v-model="games_play"
                    >
                    Lawn Tennis
                    </label>

                    <label class="d-flex align-items-center">
                    <input 
                        type="checkbox" 
                        class="radio-btn me-2" 
                        value="Squash" 
                        :disabled="games_play.length >= 2 && !games_play.includes('Squash')"
                        v-model="games_play"
                    >
                    Squash
                    </label>

                    <label class="d-flex align-items-center">
                    <input 
                        type="checkbox" 
                        class="radio-btn me-2" 
                        value="Billiards/Snooker" 
                        :disabled="games_play.length >= 2 && !games_play.includes('Billiards/Snooker')"
                        v-model="games_play"
                    >
                    Billiards/Snooker
                    </label>

                    <label class="d-flex align-items-center">
                    <input 
                        type="checkbox" 
                        class="radio-btn me-2" 
                        value="Darts" 
                        :disabled="games_play.length >= 2 && !games_play.includes('Darts')"
                        v-model="games_play"
                    >
                    Darts
                    </label>

                    <label class="d-flex align-items-center">
                    <input 
                        type="checkbox" 
                        class="radio-btn me-2" 
                        value="Table Tennis" 
                        :disabled="games_play.length >= 2 && !games_play.includes('Table Tennis')"
                        v-model="games_play"
                    >
                    Table Tennis
                    </label>

                    <label class="d-flex align-items-center">
                    <input 
                        type="checkbox" 
                        class="radio-btn me-2" 
                        value="Other Games (Gymnasium, etc.)" 
                        :disabled="games_play.length >= 2 && !games_play.includes('Other Games (Gymnasium, etc.)')"
                        v-model="games_play"
                    >
                    Other Games (Gymnasium, etc.)
                    </label>
                </div>
                </div>
            </div>
            
            <h2>Section E: Required Documents</h2>
            <p>Please attach the following documents to support your application</p>
            <div class="document-label">
                <label>Passport photograph<span>*</span></label>
            </div>
            <!-- First Document Upload -->
            <div 
                class="document-upload"
                @dragover.prevent="dragOver4 = true"
                @dragleave.prevent="dragOver4 = false"
                @drop.prevent="handleDrop($event, 4)"
                :class="{ 'drag-over': dragOver4 }"
            >
                <!-- <img src="/../assets/images/Document Medicine.svg" alt=""> -->
                <p class="document-text">
                Drop your first document here, or 
                <label for="fileInput4" class="browse-link">browse</label>
                </p>
                <p class="document-text2">PNG, JPG, GIF are allowed</p>

                <input 
                type="file" 
                id="fileInput4" 
                accept=".gif,.png,.jpg"
                @change="handleFileChange($event, 4)"
                hidden
                />

                <div v-if="file4" class="uploaded-file mt-3">
                <strong>Uploaded:</strong> {{ file4.name }}
                </div>
            </div>

            <div class="document-label">
                <label>Bankers (Please attach 6 months personal or company statement)<span>*</span></label>
            </div>
            <!-- First Document Upload -->
            <div 
                class="document-upload"
                @dragover.prevent="dragOver1 = true"
                @dragleave.prevent="dragOver1 = false"
                @drop.prevent="handleDrop($event, 1)"
                :class="{ 'drag-over': dragOver1 }"
            >
                <!-- <img src="/../assets/images/Document Medicine.svg" alt=""> -->
                <p class="document-text">
                Drop your first document here, or 
                <label for="fileInput1" class="browse-link">browse</label>
                </p>
                <p class="document-text2">PDF, PNG, JPG are allowed</p>

                <input 
                type="file" 
                id="fileInput1" 
                accept=".pdf,.png,.jpg"
                @change="handleFileChange($event, 1)"
                hidden
                />

                <div v-if="file1" class="uploaded-file mt-3">
                    <strong>Uploaded:</strong> {{ file1.name }}
                </div>
            </div>

            <p>&nbsp;</p>
            <div class="document-label">
                <label> Valid Means of Identification (e.g., Passport, Driver’s License, National ID, Voter’s Card)<span>*</span></label>
            </div>
           <!-- Second Document Upload -->
            <div 
                class="document-upload mt-4"
                @dragover.prevent="dragOver2 = true"
                @dragleave.prevent="dragOver2 = false"
                @drop.prevent="handleDrop($event, 2)"
                :class="{ 'drag-over': dragOver2 }"
            >
                <!-- <img src="/../assets/images/Document Medicine.svg" alt=""> -->
                <p class="document-text">
                Drop your second document here, or 
                <label for="fileInput2" class="browse-link">browse</label>
                </p>
                <p class="document-text2">PDF, PNG, JPG are allowed</p>

                <input 
                type="file" 
                id="fileInput2" 
                accept=".pdf,.png,.jpg"
                @change="handleFileChange($event, 2)"
                hidden
                />

                <div v-if="file2" class="uploaded-file mt-3">
                <strong>Uploaded:</strong> {{ file2.name }}
                </div>
            </div>
            <p>&nbsp;</p>
            <div class="document-label">
                <label>Recent Utility Bill (not older than 3 months)<span>*</span></label>
            </div>
            <!-- Third Document Upload -->
            <div 
                class="document-upload mt-4"
                @dragover.prevent="dragOver3 = true"
                @dragleave.prevent="dragOver3 = false"
                @drop.prevent="handleDrop($event, 3)"
                :class="{ 'drag-over': dragOver3 }"
            >
                <!-- <img src="/../assets/images/Document Medicine.svg" alt=""> -->
                            <p class="document-text">
                            Drop your third document here, or 
                            <label for="fileInput3" class="browse-link">browse</label>
                            </p>
                            <p class="document-text2">PDF, PNG, JPG are allowed</p>

                            <input 
                            type="file" 
                            id="fileInput3" 
                            accept=".pdf,.png,.jpg"
                            @change="handleFileChange($event, 3)"
                            hidden
                            />

                <div v-if="file3" class="uploaded-file mt-3">
                <strong>Uploaded:</strong> {{ file3.name }}
                </div>
            </div>

            <!-- sponsor Details -->
            <h2 class="mt-4">Section F: Sponsorship</h2>
            <p>
                Applicants must be sponsored by Two financial members of the Club of not less than five (5) years standing and supported by two members of the Executive committee
            </p>
            <p>Sponsors (2 Financial Members, 5+ years standing) <span>*</span></p>
            <div class="form-grid">
                <!-- Last Name -->
                <div class="form-group">
                  <label>1. Last Name</label>
                    <input placeholder="Enter sponsor last name" v-model="sponsorLastname" type="text" required/>
                </div>

                <!-- First Name -->
                <div class="form-group">
                    <label>First Name</label>
                    <input placeholder="Enter sponsor first name" v-model="sponsorFirstname" type="text" required/>
                </div>

                <!-- Surname -->
                <div class="form-group">
                    <label>Membership ID</label>
                    <input placeholder="Enter membership Id" v-model="sponsorId" type="text" required />
                </div>
            </div>

            <div class="form-grid">
                <!-- Last Name -->
                <div class="form-group">
                   <label>2. Last Name</label>
                    <input placeholder="Enter sponsor last name" v-model="sponsorLastname2" type="text" required/>
                </div>

                <!-- First Name -->
                <div class="form-group">
                    <label>First Name</label>
                    <input placeholder="Enter sponsor first name" v-model="sponsorFirstname2" type="text" required/>
                </div>

                <!-- Surname -->
                <div class="form-group">
                    <label>Membership ID</label>
                    <input placeholder="Enter membership Id" v-model="sponsorId2" type="text" required/>
                </div>
            </div>

            <p>Supporters (2 Executive Committee Members) <span>*</span></p>
            <div class="form-grid">
                <!-- Last Name -->
                <div class="form-group">
                    <label>1. Last Name</label>
                    <input placeholder="Enter executive last name" v-model="executiveLastname" type="text" required/>
                </div>

                <!-- First Name -->
                <div class="form-group">
                    <label>First Name</label>
                    <input placeholder="Enter executive first name" v-model="executiveFirstname" type="text" required/>
                </div>

                <!-- Surname -->
                <div class="form-group">
                    <label>Membership ID</label>
                    <input placeholder="Enter membership Id" v-model="executiveId" type="text" required />
                </div>
            </div>

            <div class="form-grid">
                <!-- Last Name -->
                <div class="form-group">
                    <label>2. Last Name</label>
                    <input placeholder="Enter executive last name" v-model="executiveLastname2" type="text" required/>
                </div>

                <!-- First Name -->
                <div class="form-group">
                    <label>First Name</label>
                    <input placeholder="Enter executive first name" v-model="executiveFirstname2" type="text" required />
                </div>

                <!-- Surname -->
                <div class="form-group">
                    <label>Membership ID</label>
                    <input placeholder="Enter membership Id" v-model="executiveId2" type="text" required/>
                </div>
            </div>

             <!-- sponsor Details -->
             <h2 class="mt-4">Section G: Declaration</h2>
             
             <p>
                I, <input type="text" style="border: none; border-bottom: 1px solid #000; width: 250px; outline: none;" v-model="signature_name" required><span>*</span>, 
                declare that the information provided above is true and correct. 
             </p>
             <div class="form-grid">
                
                <!-- Signture -->
                <div class="form-group">
                    <label>Signature<span>*</span></label>
                    <canvas ref="signatureCanvas" 
                            width="300" height="50" 
                            style="border:1px solid #000; border-radius: 6px;" required>
                    </canvas>
                    <div class="mt-2">
                        <button class="clear-btn" type="button" @click="clearSignature">Clear</button>
                    </div>
                    <input type="hidden" v-model="signature" />
               </div>

               <div class="form-group">
                <label>Date <span>*</span></label>
                <input 
                    v-model="submit_date" 
                    type="date" 
                    :min="today" 
                    :max="today" 
                    onkeydown="return false"
                    required
                />
                </div>


           </div>
            <div class="form-grid">
                
                 <!-- Email -->
                 <div class="form-group">
                    <label>Username<span>*</span></label>
                    <input placeholder="Please create your username" v-model="memberId" type="text" required readonly/>
                </div>

                <!-- Job Title -->
                <div class="form-group">
                    <label> Password<span>*</span></label>
                    <input placeholder="Please create default password" v-model="password" type="password" required />
                </div>

            </div>
            <button class="register-btn" @click="submitForm" v-if="!loading">Submit Form</button>
            <button class="register-btn" type="button" v-if="loading">
                <i class="fas fa-spinner fa-spin"></i>
            </button>
        </div>
    </div>
</template>
<script setup>
/* eslint-disable */
import { CircleAlert, ArrowLeft } from "lucide-vue-next";
import { reactive, computed, onMounted, onBeforeUnmount, ref } from "vue";
import router from "@/router";
import axios from 'axios';
import SignaturePad from "signature_pad";

// Personal Info
const lastName = ref("");
const firstName = ref("");
const otherName = ref("");
const memberId = ref("");
const dob = ref("");
const nationality = ref("");
const residential_address = ref("");
const phone = ref("");
const email = ref("");
const profession = ref("")
const employer = ref("")
const empl_office_address = ref("")
const empl_office_phone = ref("")
const jobTitle = ref("");

const club_members = ref("");
const expelled = ref("")
const reason_expelled = ref("")
const games_play = ref([]);
const signature = ref("");
const password = ref("");

// Sponsor Info
const sponsorLastname = ref("");
const sponsorFirstname = ref("");
const sponsorId = ref("");
const sponsorLastname2 = ref("");
const sponsorFirstname2 = ref("");
const sponsorId2 = ref("");

const executiveLastname = ref("");
const executiveFirstname = ref("");
const executiveId = ref("");
const executiveLastname2 = ref("");
const executiveFirstname2 = ref("");
const executiveId2 = ref("");

// Refs
const signature_name = ref("");
const signatureCanvas = ref(null);
const signaturePad = ref(null);
const submit_date = ref(null);
const today = new Date().toISOString().substring(0, 10);

// Children Info
const children = ref([]);


// File states
const file1 = ref(null);
const file2 = ref(null);
const file3 = ref(null);
const file4 = ref(null);

// Drag states
const dragOver1 = ref(false);
const dragOver2 = ref(false);
const dragOver3 = ref(false);
const dragOver4 = ref(false);
let loading = ref(false);

const arrow_back = () => {
    router.push("/");
}

const addChild = () => {
  if (children.value.length < 6) {
    children.value.push({ name: "", sex: "", dob: "" });
  }
};

const removeChild = (index) => {
  children.value.splice(index, 1);
};

// Lifecycle hook
onMounted(() => {
  signaturePad.value = new SignaturePad(signatureCanvas.value);
});

const clearSignature = () => {
  signaturePad.value.clear();
};

const saveSignature = () => {
  if (!signaturePad.value.isEmpty()) {
    signature.value = signaturePad.value.toDataURL(); // save as base64 image
  } else {
    alert("Please sign before saving.");
  }
};

// Handle file input change
const handleFileChange = (e, target) => {
  const selectedFile = e.target.files[0];
  if (selectedFile) validateAndSetFile(selectedFile, target);
};

// Handle drag-and-drop
const handleDrop = (e, target) => {
  const droppedFile = e.dataTransfer.files[0];
  if (droppedFile) validateAndSetFile(droppedFile, target);
};

// Validate allowed files
const validateAndSetFile = (f, target) => {
    const allowedTypes = [
    "application/pdf",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "image/gif",
    "image/png",
    "image/jpeg"
    ];
  if (allowedTypes.includes(f.type)) {
    if (target === 4) file4.value = f;
  } else {
    alert("Only GIF, PNG, JPG are allowed.");
  }

  if (allowedTypes.includes(f.type)) {
    if (target === 1) file1.value = f;
    if (target === 2) file2.value = f;
    if (target === 3) file3.value = f;
  } else {
    alert("Only PDF, PNG, JPG are allowed.");
  }
};

const validateDob = (child, index) => {
  if (!child.dob) return;

  const dob = new Date(child.dob);
  const today = new Date();

  const age = today.getFullYear() - dob.getFullYear();
  const monthDiff = today.getMonth() - dob.getMonth();
  const dayDiff = today.getDate() - dob.getDate();

  // Adjust if the birthday hasn’t occurred yet this year
  const realAge = monthDiff < 0 || (monthDiff === 0 && dayDiff < 0) ? age - 1 : age;

  if (realAge > 25) {
    alert(`Child ${index + 1}: Age cannot be more than 25 years.`);
    child.dob = ""; // Reset invalid DOB
  }
};

const submitForm = async () => {

// Build an object of required fields
const requiredFields = {
  lastname: lastName.value,
  firstname: firstName.value,
  memberId: memberId.value,
  date_of_birth: dob.value,
  nationality: nationality.value,
  address: residential_address.value,
  phone: phone.value,
  email: email.value,
  profession: profession.value,
  employer: employer.value,
  empl_office_address: empl_office_address.value,
  work_status: jobTitle.value,
  other_club_membership: club_members.value,
  expelled: expelled.value,
  reason_expelled: reason_expelled.value,
  game_interest: games_play.value,
  first_sponsor_firstname: sponsorFirstname.value,
  first_sponsor_lastname: sponsorLastname.value,
  first_sponsorId: sponsorId.value,
  second_sponsor_firstname: sponsorFirstname2.value,
  second_sponsor_lastname: sponsorLastname2.value,
  second_sponsorId: sponsorId2.value,
  first_executive_firstname: executiveFirstname.value,
  first_executive_lastname: executiveLastname.value,
  first_executiveId: executiveId.value,
  second_executive_firstname: executiveFirstname2.value,
  second_executive_lastname: executiveLastname2.value,
  second_executiveId: executiveId2.value
};

// ✅ Validate required fields
for (const [key, value] of Object.entries(requiredFields)) {
  if (
    value === null ||
    value === undefined ||
    value === "" ||
    (Array.isArray(value) && value.length === 0)
  ) {
    alert(`Please fill in the required field: ${key.replace(/_/g, " ")}`);
    return; // Stop submission
  }
}
    
  loading.value = true
  // ✅ Build FormData for text + files
  const formData = new FormData();

  // Personal info
  formData.append("lastname", lastName.value);
  formData.append("firstname", firstName.value);
  formData.append("othernames", otherName.value);
  formData.append("memberId", memberId.value);
  formData.append("date_of_birth", dob.value);
  formData.append("nationality", nationality.value);
  formData.append("address", residential_address.value);
  formData.append("phone", phone.value);
  formData.append("email", email.value);
  formData.append("profession", profession.value);
  formData.append("employer", employer.value);
  formData.append("empl_office_address", empl_office_address.value);
  formData.append("empl_office_phone", empl_office_phone.value);
  formData.append("work_status", jobTitle.value);

  formData.append("other_club_membership", club_members.value);
  formData.append("expelled", expelled.value);
  formData.append("reason_expelled", reason_expelled.value);
  formData.append("game_interest", JSON.stringify(games_play.value));

  // Sponsors
  formData.append("first_sponsor_firstname", sponsorFirstname.value);
  formData.append("first_sponsor_lastname", sponsorLastname.value);
  formData.append("first_sponsorId", sponsorId.value);
  formData.append("second_sponsor_firstname", sponsorFirstname2.value);
  formData.append("second_sponsor_lastname", sponsorLastname2.value);
  formData.append("second_sponsorId", sponsorId2.value);

  // Executive
  formData.append("first_executive_firstname", executiveFirstname.value);
  formData.append("first_executive_lastname", executiveLastname.value);
  formData.append("first_executiveId", executiveId.value);
  formData.append("second_executive_firstname", executiveFirstname2.value);
  formData.append("second_executive_lastname", executiveLastname2.value);
  formData.append("second_executiveId", executiveId2.value);

  // Children (as JSON)
  formData.append("children", JSON.stringify(children.value));

  // ✅ Signature (base64 image)
  if (signaturePad.value && !signaturePad.value.isEmpty()) {
    const signatureDataUrl = signaturePad.value.toDataURL("image/png");
    // Convert base64 to Blob
    const byteString = atob(signatureDataUrl.split(",")[1]);
    const mimeString = signatureDataUrl.split(",")[0].split(":")[1].split(";")[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ab], { type: mimeString });

    // Append to formData as a file
    formData.append("signature", blob, "signature.png");
  }

  formData.append("signature_name", signature_name.value);
  formData.append("submit_date", submit_date.value);

  formData.append("username", memberId.value);
  formData.append("password", password.value);

  // ✅ Documents (files)
  if (file1.value) formData.append("document1", file1.value);
  if (file2.value) formData.append("document2", file2.value);
  if (file3.value) formData.append("document3", file3.value);
  if (file4.value) formData.append("document4", file4.value);
  try {
    const response = await axios.post("/create_members.php", formData, {
      headers: { "Content-Type": "multipart/form-data" }
    });

    loading.value = false

    alert("✅ " + response.data.message);
    

  } catch (error) {
    console.error(error);
    loading.value = false
    alert(error.response ? error.response.data.message : error.message);
  }
};


</script>

<style scoped lang="scss">


@media (max-width: 768px) {
.banner{
    padding: 20px 30px 135px 30px;
    opacity: 1;

    h2{
        font-family: BT Beau Sans;
        font-weight: 500;
        font-style: Medium;
        font-size: 40px;
        line-height: 40px;
        text-align: center !important;
        color: #FFFFFF;
        margin-bottom: 20px;
    }
    h4{
        font-family: Open Runde;
        font-weight: 500;
        font-style: Medium;
        font-size: 15px;
        line-height: 19px;
        text-align: center !important;
        color: #FFFFFF;
    }
}
}
.form-container {
    max-width: 90%;
    margin: 0 auto;
    padding: 24px;

    .arrow-left{
        color: #DB6813;
        text-align: left;
        cursor: pointer;
    }

    h2 {
        font-size: 24px;
        font-weight: 600;
        margin-bottom: 8px;
        text-align: left;
    }

    p {
        color: #666;
        margin-bottom: 24px;
        text-align: left;
    }

    @media (max-width: 768px) {
        max-width: 100%;
        padding: 20px;

    }
}

.form-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;
    margin-bottom: 30px;

    @media (min-width: 1024px) {
        grid-template-columns: repeat(3, 1fr);
    }
}

.form-group {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    label {
        font-size: 15px;
        font-weight: 500;
        margin-bottom: 6px;
        color: #30373D;
    }

    input,
    select,
    textarea {
        padding: 10px 12px;
        border: 1px solid #D1D1D1;
        width: 100%;
        /* gray-300 */
        border-radius: 14px;
        font-size: 14px;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;

        &:focus {
            border-color: #2563eb;
            /* blue-600 */
            box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.3);
            outline: none;
        }
    }
}

.form-group{
    .radio-btn {
        width: 42px;
        height: 42px;
        opacity: 1;
        background: #3D3D3D !important;
    }
}

.membership-form-grid{
    margin-bottom: 20px;
}
.membership-options {
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    width: 100%;

    label { 
        align-items: center !important;
        margin-right: 10px !important;
    }
}
.document-label{
    font-family: BT Beau Sans;
    font-weight: 500;
    font-style: Medium;
    font-size: 15px;
    line-height: 20px;
    text-align: left !important;
}
.document-upload{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 170px;
    opacity: 1;
    border-radius: 8px;
    border-width: 1px;
    padding-top: 28px;
    padding-right: 16px;
    padding-bottom: 28px;
    padding-left: 16px;
    border-style: dashed;
    cursor: pointer;

    img{
        width: 40px;
        height: 40px;
    }
    .document-text{
        font-family: Open Sans;
        font-weight: 600;
        font-style: SemiBold;
        font-size: 14px;
        line-height: 0px;
        text-align: center;
        margin-top: 15px;
    }
    .document-text2{
        font-family: Open Sans;
        font-weight: 600;
        font-style: SemiBold;
        font-size: 14px;
        line-height: 10px;
        text-align: center;
    }
}
@media (max-width: 768px) {
.document-upload{

    img{
        width: 30px;
        height: 30px;
    }
    .document-text{
        font-weight: 500;
        font-size: 12px;
    }
    .document-text2{
        font-weight: 500;
        font-size: 12px;
        line-height: 0px;
        margin-top: -8px;
    }
}
}
.document-upload.drag-over {
  border-color: #007bff;
  background: #f0f8ff;
}
.browse-link {
  color: #007bff;
  cursor: pointer;
  text-decoration: underline;
}
@media (max-width: 768px) { 
    .browse-link {
        margin-top: 20px;
    }
}
.uploaded-file {
  font-size: 14px;
  color: #333;
}
@media (max-width: 768px) {
    .membership-options {
        display: flex;
        flex-direction: column;
        justify-content: left;
        align-items:flex-start;

        label { 
            align-items:flex-start !important;
            margin-right: 0px !important;
        }
    }
}

.clear-btn{
    border: 0px;
    border-radius: 10px;
    font-family: Open Sans;
    font-weight: 400;
    font-style: SemiBold;
    font-size: 13px;
}
.register-btn {
    width: 450px;
    padding: 14px 12px;
    background: white;
    border: 0px solid #00000033;
    color: #FFFFFF;
    background: #ED4E24;
    font-size: 16px;
    font-weight: 600;
    border-radius: 60px;
    cursor: pointer;
    margin-top: 0.2rem;
    transition: background 0.3s ease;
    margin-bottom: 6.2rem;
}
@media (max-width: 768px) {
    .register-btn {
        width: 250px;
    }
}
.children-section {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    width: 100%;
}

.child-form {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
    width: 100%;
    margin-bottom: 20px;

    @media (min-width: 768px) {
        grid-template-columns: repeat(3, 1fr);
        width: 95%;
    }
}

.child-number {
    font-weight: 600;
    margin-bottom: 8px;
    color: #374151;
    width: 5%;
}

.sex-options {
    display: flex;
    gap: 16px;

    label {
        font-size: 14px;
        font-weight: 400;
        display: flex;
        align-items: center;
        gap: 6px;
    }

    .CheckBox {
        width: 40px;
        height: 40px;
        border: 1px solid blue;
    }
}

.add-child-btn {
    padding: 10px 16px;
    border: 1px solid #D1D1D1;
    background-color: #FFFFFF;
    color: #000000;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: background 0.2s ease;

    &:hover:enabled {
        background-color: #a5a2a2;
    }

    &:disabled {
        background-color: #a5b4fc;
        cursor: not-allowed;
    }
}
</style>
